import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let $: any;
@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.css'],
})
export class BlogDetailsComponent implements OnInit {
  private getApi = environment.url + environment.blogGet;
  /**
   * Constructor for BlogDetailsComponent.
   * @param route - Service to access route parameters.
   * @param router - Service to navigate the router.
   * @param makeapi - Service to make API calls.
   * @param getdata - Service to manage application state.
   */
  constructor(
    private route: ActivatedRoute, // Injects ActivatedRoute to access route parameters
    private router: Router, // Injects Router for navigation
    private makeapi: ApiService, // Injects ApiService for API calls
    private getdata: ValueService // Injects ValueService for managing application state
  ) {}

  /**
   * Initializes the component.
   * Subscribes to query parameters, filtering by presence of _id.
   * When a query parameter with _id is present, calls the getBlog method to fetch the blog details.
   */
  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true); // Show the loading indicator
    this.route.queryParams
      .pipe(
        filter((params) => params._id) // Filter by presence of _id query parameter
      )
      .subscribe((params) => {
        this.getBlog(atob(params._id)); // Get the blog details by decoding the _id
      });
  }
  blogView: any = {};
  /**
   * Gets the blog details from the API for the given ID.
   * @param _id - The ID of the blog to get.
   */
  getBlog(_id: any) {
    // Show the loading indicator
    this.getdata.amizhthLoader('show');
    // Make the API request to get the blog details
    this.makeapi
      .method(this.getApi + 'id=' + _id, '', 'getunauth')
      .subscribe((data) => {
        // Hide the loading indicator
        this.getdata.amizhthLoader('hide');
        // Update the blog details
        this.blogView = data;
        // Add the active class to the first carousel item
        $(document).ready(function () {
          $('.carosal0').addClass('active');
        });
      });
  }
  /**
   * Navigates back to the blog list page.
   */
  backBtn() {
    // Navigate back to the blog list page
    this.router.navigateByUrl('/blog');
  }
}
